import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69eda13c63911b00146e8320/vidalivre/src/app/politica-de-privacidade/page.tsx");
